import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function DeveloperRoute({ children }) {
  const { user } = useAuth();

  // Check if user is developer or superuser
  const isDeveloper = user?.role === 'developer' || user?.role === 'superuser';

  if (!user) {
    // Not logged in
    return <Navigate to="/login" />;
  }

  if (!isDeveloper) {
    // Logged in but not a developer
    return <Navigate to="/" />;
  }

  // User is a developer or superuser
  return children;
}

export default DeveloperRoute;